import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class ReconnectLinkCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend,
  ) { }

  async run(bank_account_id:string, company_id:Number, institution:string, kind:string, service:string): Promise<any> {
    let args = {
      bank_account_id: bank_account_id,
      company_id: company_id,
      use_sandbox: institution == 'Sandbox'
    }
    this.frontend.reconnectPopupLoading = true
    let res = await this.dispatcher.dispatch('get.reconnect.link', args)
    this.frontend.reconnectPopupLoading = false
    this.frontend.reconnectPopup = false
    if (res.output['status'] === 'ok') {
      if (kind=='afterbanks') {
        this.frontend.$router.push({name: 'bank-creation', params: { company_id: company_id, bank_account_id: bank_account_id, service_id: service}});
      } else {
        window.location.href = res.output['info']
      }
    } else {
      this.frontend.generic_error_msg = 'Se ha producido un error al intentar reconectar. Por favor, inténtelo de nuevo más tarde.'
      this.frontend.show_generic_error = true
    }
  }
}